import { render, staticRenderFns } from "./VTaskRewards.vue?vue&type=template&id=3aa4031c&scoped=true"
import script from "./VTaskRewards.vue?vue&type=script&lang=ts"
export * from "./VTaskRewards.vue?vue&type=script&lang=ts"
import style0 from "./VTaskRewards.vue?vue&type=style&index=0&id=3aa4031c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa4031c",
  null
  
)

export default component.exports